const cmaOps = require('./cmaOperations');

const parameters = {
  cma_params_mpbf_1: 0.25,
  cma_params_mpbf_2: 0.25,
};

let newArr = null;

module.exports = function (arrayLength, cma_mpbf_values, cma_bsa_values, cma_bs_values) {

  /*
    Not using the below calculation as cma_bs_68 is not defined in our CMA (but is present in the kute and icici CMAs)
   */
  // cma_mpbf_values.cma_mpbf_2 = cmaOps.difference(cma_bsa_values.cma_bsa_29, cma_bs_values.cma_bs_68);

  cma_mpbf_values.cma_mpbf_2 = cma_bsa_values.cma_bsa_29;

  cma_mpbf_values.cma_mpbf_3 = cma_bsa_values.cma_bsa_41;

  cma_mpbf_values.cma_mpbf_4 = cmaOps.difference(cma_mpbf_values.cma_mpbf_2, cma_mpbf_values.cma_mpbf_3);

  cma_mpbf_values.cma_mpbf_5 = cmaOps.multiplyParameter(cmaOps.difference(cma_mpbf_values.cma_mpbf_4, cma_bsa_values.cma_bsa_18), parameters.cma_params_mpbf_1);

  cma_mpbf_values.cma_mpbf_6 = cma_bs_values.cma_bs_119;

  cma_mpbf_values.cma_mpbf_7 = cmaOps.difference(cma_mpbf_values.cma_mpbf_4, cma_mpbf_values.cma_mpbf_5);
  cma_mpbf_values.cma_mpbf_8 = cmaOps.difference(cma_mpbf_values.cma_mpbf_4, cma_mpbf_values.cma_mpbf_6);

  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = (cma_mpbf_values.cma_mpbf_7[i] < cma_mpbf_values.cma_mpbf_8[i]) ? cma_mpbf_values.cma_mpbf_7[i] : cma_mpbf_values.cma_mpbf_8[i];
  }
  cma_mpbf_values.cma_mpbf_9 = newArr;

  cma_mpbf_values.cma_mpbf_10 = cmaOps.onlyPositiveDifference(cma_mpbf_values.cma_mpbf_5, cma_mpbf_values.cma_mpbf_6);


  cma_mpbf_values.cma_mpbf_12 = cma_bsa_values.cma_bsa_29;
  cma_mpbf_values.cma_mpbf_13 = cma_bsa_values.cma_bsa_41;
  cma_mpbf_values.cma_mpbf_14 = cmaOps.difference(cma_mpbf_values.cma_mpbf_12, cma_mpbf_values.cma_mpbf_13);

  cma_mpbf_values.cma_mpbf_15 = cmaOps.multiplyParameter(cmaOps.difference(cma_bsa_values.cma_bsa_29, cma_bsa_values.cma_bsa_18), parameters.cma_params_mpbf_2);

  cma_mpbf_values.cma_mpbf_16 = cma_bs_values.cma_bs_119;
  cma_mpbf_values.cma_mpbf_17 = cmaOps.difference(cma_mpbf_values.cma_mpbf_14, cma_mpbf_values.cma_mpbf_15);
  cma_mpbf_values.cma_mpbf_18 = cmaOps.difference(cma_mpbf_values.cma_mpbf_14, cma_mpbf_values.cma_mpbf_16);

  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = (cma_mpbf_values.cma_mpbf_17[i] < cma_mpbf_values.cma_mpbf_18[i]) ? cma_mpbf_values.cma_mpbf_17[i] : cma_mpbf_values.cma_mpbf_18[i];
  }
  cma_mpbf_values.cma_mpbf_19 = newArr;

  cma_mpbf_values.cma_mpbf_20 = cmaOps.onlyPositiveDifference(cma_mpbf_values.cma_mpbf_15, cma_mpbf_values.cma_mpbf_16);

  return cma_mpbf_values;
};



// WEBPACK FOOTER //
// ./src/cma/calculations_MPBF.js